<template>
  <div class="sxKqIndex">
    <Header title="实习考勤" type="0" route="/homeIndex"></Header>
    <div class="research">
      <span @click="showPop('学年学期', 'xnxq')">
        <i>学年学期：{{ xnxq.mc }}</i>
        &nbsp;&nbsp;
        <b></b>
      </span>
    </div>
    <NOdata
      v-if="(this.list && this.list.length == 0) || this.list == '[]'"
      title="未查询到实习考勤"
    ></NOdata>
    <div v-else class="list-item">
      <div class="content" v-for="(item, index) in list" :key="index">
        <div class="top">
          <p>{{ item.kcmc }}[{{ item.kch }}]</p>
          <ul>
            <li>实习项目：{{ item.xmmc }}</li>
            <li>指导老师：{{ item.jsxm }}</li>
            <li>任务类型：{{ item.xmlx }}</li>
            <li>任务编号：{{ item.rwbh }}</li>
          </ul>
        </div>
        <div class="operate">
          <span @click="goKQ(item)">考勤</span>
          <span @click="goItem(item)">明细</span>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      show: false,
      xnxq: {},
      valueList: {
        label: "",
        value: "",
        item: []
      },
      columns: {},
      list: []
    };
  },
  methods: {
    async getList() {
      const res = await Api.getsxkqrwlist1({
        xnxq: this.xnxq.dm
      });
      this.list = res.data;
    },
    // 跳转到明细页面
    goItem(item) {
      item.route = "/sxKq/index";
      item.xnxq = this.xnxq.dm;
      item.title = "考勤明细";
      this.$router.push({
        path: "/sxKq/item",
        query: {
          list: item
        }
      });
    },
    // 跳转到考勤页面
    goKQ(item) {
      item.xnxq = this.xnxq.dm;
      this.$router.push({
        path: "/sxKq/KQ",
        query: {
          list: JSON.stringify(item)
        }
      });
    },
    // 获取学年学期
    async getXnxq() {
      let xnxqDefaultIndex = 0;
      const res = await Api.getXnxq();

      this.columns.xnxq = [
        {
          values: res.data.map((item, index) => {
            if (item.isdqxq === "1") {
              this.xnxqDefaultIndex = index;
              this.xnxq = {
                dm: item.xnxq01id,
                mc: item.xqmc
              };
            }
            if (
              this.$route.query.xnxq &&
              this.$route.query.xnxq == item.xnxq01id
            ) {
              this.xnxq = {
                dm: item.xnxq01id,
                mc: item.xqmc
              };
              this.xnxqDefaultIndex = index;
            }
            return {
              value: item.xnxq01id,
              text: item.xqmc
            };
          }),
          defaultIndex: this.xnxqDefaultIndex
        }
      ];

      this.getList();
    },
    // 弹出选择器
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value[0].text;
      this[value1].dm = value[0].value;
      this.getList();
    }
  },
  created() {
    this.getXnxq();
  }
};
</script>
<style lang="less" scoped>
.sxKqIndex {
  .research {
    z-index: 9999;
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #f4f4f4;
    padding: 5% 5% 3% 5%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    background-color: #fff;

    span {
      height: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #757da3;
      letter-spacing: 0;
      text-align: right;
      display: inline-flex;
      align-items: center;
      i {
        font-style: normal;
      }
      b {
        display: inline-block;
        border-right: 3px solid transparent;
        border-left: 3px solid transparent;
        border-top: 3px solid #757da3;
      }
    }
  }
  .list-item {
    padding: 70px 20px 0 20px;
    .content {
      background: #f8f8f8;
      border-radius: 5px;
      margin-bottom: 5%;
      .top {
        padding: 20px 20px 10px 20px;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          margin-bottom: 10px;
        }
        ul li {
          height: 17px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 5px;
        }
      }
      .operate {
        border-top: 1px solid #dee1e9;
        display: block;
        height: 40px;
        line-height: 40px;
        display: flex;
        width: 100%;
        span {
          flex: 1;
          font-family: PingFangSC-Regular;
          font-size: 15px;
          color: #212f6e;
          letter-spacing: 0;
          text-align: center;
          font-weight: bold;
          cursor: pointer;
          &:first-child {
            border-right: 1px solid #dee1e9;
          }
        }
      }
    }
  }
  .icon {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxKq/index.vue